import { render, staticRenderFns } from "./scroll-loader.vue?vue&type=template&id=3d934059"
import script from "./scroll-loader.vue?vue&type=script&lang=js"
export * from "./scroll-loader.vue?vue&type=script&lang=js"
import style0 from "./scroll-loader.vue?vue&type=style&index=0&id=3d934059&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports